module.exports = __webpack_public_path__ + "resources/img/loading.gif";